// 기본 색상 (좌표계 X, Y, Z 축 색상과 동일)
export const COLOR_RED = '#ff4d4f';
export const COLOR_GREEN = '#52c41a';
export const COLOR_BLUE = '#1890ff';

// Token colors (별칭)
export const INPUT_TOKEN_COLOR = COLOR_GREEN;
export const OUTPUT_TOKEN_COLOR = COLOR_RED;

// UI colors
export const BACKGROUND_OVERLAY = 'rgba(0, 0, 0, 0.8)';
export const BACKGROUND_DARK = '#1a1a1a';
export const BORDER_COLOR = '#444';
export const BUTTON_DISABLED_COLOR = '#666';
export const WHITE = '#ffffff';
